import { Protocol } from '../Protocol';

export class MaterialFactoryCodeProtocol {
  public static readonly ALL_BOM: string = `${Protocol.YATUNG_API_ROOT}/bom/search`; // 取得所有物料表紀錄
  public static readonly BOM_URL: string = `${Protocol.YATUNG_API_ROOT}/bom`; // 修改 & 新增物料表紀錄
  public static readonly BOM_HIERARCHY: string = `${Protocol.YATUNG_API_ROOT}/bom/hierarchy`; //
}
